// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductDetailed_wrapper__Jz5Om","gallery":"ProductDetailed_gallery__MrMLI","info":"ProductDetailed_info__RuGXa"};